import Vue from 'vue'
import isURL from 'validator/lib/isURL'

Vue.mixin({
  methods: {
    isURL
  }
})
